<template>
  <div
    class="modal fade createNewModal"
    id="AddModalZone"
    tabindex="-1"
    ref="addZoneModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="zoneForm" @submit="addZone" :validation-schema="zoneSchema">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom de la zone  <span class="text-danger">*</span>
                  </label>
                  <Field name="name" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez le nom de la zone"/>
                  <ErrorMessage name="name" class="text-danger"/>
                </div>
              </div>
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error , success, hideModal } from '../../utils/utils';
import { Zone } from '@/models/Tarification';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'

export default defineComponent({
    name: "AddModalZone",
    components: {
    Form,
    Field,
    ErrorMessage,
 
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const zoneSchema = Yup.object().shape({
      name: Yup.string().required('Le nom est obligatoire'),
      
    });

    const zoneForm = ref<Zone | null>(null);
    const addZoneModalRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajoute une zone ");
    const btntext = ref('Ajouter');
    


    watch(() => props.item, (newValue) => {
      getZone(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier une zone";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter une zone";
         btntext.value = "Ajouter";
      }
    }

    const getZone = async (id: number) => {
      return ApiService.get("/zone/"+id)
      .then(({ data }) => {
        const donnees = data.data;
        for (const key in donnees) {
          zoneForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addZoneModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    const addZone = async (values: any, zoneForm) => {
      values = values as Zone;
      if(isUPDATE.value){
        ApiService.put("/zone/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              zoneForm.resetForm();
              hideModal(addZoneModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        ApiService.post("/zone",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              zoneForm.resetForm();
              hideModal(addZoneModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { 
      addZoneModalRef,
      addZone,
      zoneForm,
      title,btntext,
      resetValue,
      zoneSchema
      
    };
  },
});
</script>